/**
 * Product Q&A products API schemas (epic PI-SPEC-SW-E310, ER-1667 Package F,
 * contract ask 1).
 *
 * The panel's product picker lists the products the person may ask about:
 * one entry per scope (an ADO project they hold the `ask` capability on, or a
 * FogBugz project linked to one), with the mapped repositories and whether
 * the "Where in the code" fold starts open for them
 * (`askCodeFoldOpenByDefault`). SpecTree only lists products; it never runs
 * a question and stores no conversation.
 *
 * Response schemas are lenient, so a SpecTree release may add response
 * fields without a contract bump. Every response is wrapped as
 * `{ data: ... }`; parse the envelope with `apiDataSchema` from the grooming
 * module.
 */
import { z } from "zod";
import { askScopeSchema } from "./types.js";
/** One repository that answers questions about a product. */
export const askProductRepoSchema = z
    .object({
    repo: z.string().min(1),
    branch: z.string().min(1).optional(),
})
    .loose();
/**
 * One product the person may ask about. `reposMapped` is false when the ADO
 * project has no repositories set up yet (the panel says so instead of
 * offering a chat); `codeFoldOpen` is `askCodeFoldOpenByDefault` for the
 * person's roles on that project.
 */
export const askProductSchema = z
    .object({
    scope: askScopeSchema,
    displayName: z.string().min(1),
    reposMapped: z.boolean(),
    repos: z.array(askProductRepoSchema),
    codeFoldOpen: z.boolean(),
})
    .loose();
/** The products the person may ask about. */
export const askProductsResponseSchema = z
    .object({
    products: z.array(askProductSchema),
})
    .loose();
/** One product, as a single-product read returns it. */
export const askProductResponseSchema = askProductSchema;
//# sourceMappingURL=api.js.map